import { render, staticRenderFns } from "./session-details.vue?vue&type=template&id=e828f736"
import script from "./session-details.vue?vue&type=script&lang=js"
export * from "./session-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports